import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { ApiClientService } from "~app/common/services/api-client.service";
import { IViol3ArbetsorderAggregatPreviewData } from "./viol3-preview.model";
@Injectable({
    providedIn: "root"
})
export class Viol3PreviewService {
    private readonly apiClient = inject(ApiClientService);

    getViol3DataForArbetsorder(arbetsorderId: number, visaUtkast: boolean): Observable<IViol3ArbetsorderAggregatPreviewData> {
        return this.apiClient.get<IViol3ArbetsorderAggregatPreviewData>(`viol3/arbetsorderaggregatpreviewdata`, false, { arbetsorderId:arbetsorderId,
            visaUtkast: visaUtkast });
    }
}
